/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_SaveInputs */

const cs_ebr_conn_save = /** @type {(inputs: Ebr_Conn_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit`)
};

const en_ebr_conn_save = /** @type {(inputs: Ebr_Conn_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Ebr_Conn_SaveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_save = /** @type {((inputs?: Ebr_Conn_SaveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_SaveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_save(inputs)
	return cs_ebr_conn_save(inputs)
});